import {Panes, prefixWithSeparator, Select, TextField} from '@management-ui/core';
import {Box, FormControl, InputLabel, MenuItem, Select as MuiSelect} from '@mui/material';
import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import {useFormContext} from 'react-hook-form';
import {ServiceContext} from '../../../../components/Services';
import {joinAddress} from '../../../../utilities';

const Customs = ({list = {}, prefix = ''}) => {
  const services = useContext(ServiceContext);
  const [customers, setCustomers] = useState([]);
  const [customer, setCustomer] = useState(null);
  const [location, setLocation] = useState('');
  const optionsLoaded = useRef(false);
  const {setValue, /** @var {function(string): string} */watch} = useFormContext();
  const customerID = watch(`${prefixWithSeparator(prefix)}customer_id`);

  useEffect(() => {
    if (!optionsLoaded.current) {
      optionsLoaded.current = true;
      services.contact.getContacts({customers: '1'}, 1, 500).then((list) => {
        setCustomers(list.data.map(({id, name, locations}) => ({title: name, value: id, name, locations})));
      }).catch(() => null);
    }
  }, [services]);

  useEffect(() => {
    setCustomer(customers.find(({value}) => `${value}` === `${customerID}`));
  }, [customers, customerID]);

  useEffect(() => {
    if (customer) {
      const index = customer.locations.findIndex(({id}) => `${id}` === location);
      if (index >= 0) {
        setValue(`${prefixWithSeparator(prefix)}customer_address`, joinAddress(customer.locations[index], [customer.name]));
      }
    }
  }, [prefix, customer, location, setValue])

  const handleReset = useCallback((subject) => {
    if (subject.customer) {
      setCustomer(subject.customer);
      subject.customer_id = `${subject.customer.id}`;
    }
    return subject;
  }, []);

  return (
    <Panes
      entity={list}
      prefix={prefix}
      onReset={handleReset}
      panes={[
        {
          title: 'Customer',
          fields: [
            <Select
              name="customer_id"
              prefix={prefix}
              label="Customer"
              options={customers}
              rules={{required: 'Please select a customer'}}
            />,
            <Box marginY={2}>
              <FormControl fullWidth disabled={(customer?.locations ?? []).length < 1}>
                <InputLabel id="locationLabel">Location</InputLabel>
                <MuiSelect
                  labelId="locationLabel"
                  value={location}
                  label="Location"
                  onChange={(e) => setLocation(e.target.value)}
                >
                  {(customer?.locations ?? []).map((l, i) => (
                    <MenuItem key={i} value={`${l.id}`}>{l.name}</MenuItem>
                  ))}
                </MuiSelect>
              </FormControl>
            </Box>,
            <TextField
              name="customer_address"
              prefix={prefix}
              label="Address"
              fieldProps={{multiline: true, rows: 4}}
            />,
          ]
        },
        {
          title: '',
          fields: []
        }
      ]}
      title=""/>
  );
}

Customs.onSave = ({customer_id, customer_address}) => ({customer_id, customer_address});

export default Customs;
